<template>
  <div class="content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%;margin-top:0;">
      <el-table-column
        prop="lamp_id"
        label="序号"
        width="80"
        sortable
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="设备别名"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="number"
        label="设备识别号"
        width="160"
        align="center"
      ></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList"
export default {
  name: "deviceList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      sub_dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 40,
        stg_id:'', //策略
        lamp_protocol: '', //协议
        lamp_group: this.groupId, //灯组
        lamp_number: '', //编号
        lamp_name: ''//名称
      },
      cnt_all: 0
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该设备所选媒体文件列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
